import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const LeadModal = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Don't show modal on lead management pages
        if (location.pathname.startsWith('/leads')) {
            return;
        }

        // Check if modal has been shown in this session
        const hasModalBeenShown = sessionStorage.getItem('leadModalShown');
        if (hasModalBeenShown) {
            return;
        }

        // Show modal after 5 seconds
        const timer = setTimeout(() => {
            setIsVisible(true);
            sessionStorage.setItem('leadModalShown', 'true');
        }, 5000);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleFormSuccess = () => {
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}                    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm overflow-y-auto"
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        className="relative w-full max-w-3xl bg-white rounded-lg shadow-2xl overflow-y-auto my-4"
                    >
                        {/* Close button */}
                        <button
                            onClick={handleClose}
                            className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 z-10"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>                        {/* Content */}
                        <div className="p-4">
                            <div className="text-center mb-4">
                                <h2 className="text-xl font-bold text-gray-900">
                                    Get Expert Financial Advice
                                </h2>
                                <p className="mt-1 text-sm text-gray-600">
                                    Fill out this form to start your journey towards financial freedom
                                </p>
                            </div>

                            {/* Render the LeadTracker with onSuccess prop */}
                            <div className="max-h-[calc(100vh-12rem)] overflow-y-auto">
                                {React.cloneElement(children, { onSuccess: handleFormSuccess })}
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default LeadModal;
